<template lang="html">
    <div>
        <div class="d-flex flex-column" >
            <div class="d-flex flex-row align-items-center">
                <div class="row g-0 align-self-center align-items-center justify-content-center">
                    <div class="cta-3 text-primary">Modifié</div>
                </div>

                <button @click="delete_state()" type="button" class="btn btn-outline-primary btn-sm btn-icon btn-icon-only ms-auto"><i class="bi-trash"></i></button>
            </div>

            <div class="text-alternate">Publié le <strong>{{context.data.published_on|local_date}} /&nbsp;</strong><span>{{human_published_on}}</span></div>

            <p class="mt-1"><strong>Modifications</strong></p>
            <table class="table is-narrow" style="font-size: 0.85em;">
            <thead>
                <tr>
                    <th>Champ</th>
                    <th>Ancienne valeur</th>
                    <th>Nouvelle valeur</th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="item of context.data.modified_items" :key="item.field_verbose_name">
                    <td class="field-name">{{item.field_verbose_name}}</td>
                    <template v-if="isTextField(item.field_verbose_name) && String(item.old_value) !== String(item.new_value)">
                        <td class="diff-cell" v-html="diffOld(item.old_value, item.new_value)"></td>
                        <td class="diff-cell" v-html="diffNew(item.old_value, item.new_value)"></td>
                    </template>
                    <template v-else>
                        <td :style="String(item.old_value) !== String(item.new_value) ? 'background-color:#facbcb;' : ''">{{item.old_value}}</td>
                        <td :style="String(item.old_value) !== String(item.new_value) ? 'background-color:#cefacb;' : ''">{{item.new_value}}</td>
                    </template>
                </tr>
            </tbody>
            </table><br/>
        </div>
    </div>
</template>

<script>
import moment from "moment";
import * as diff from "diff";
moment.locale("fr");

// Libellés exacts des champs texte à comparer (field_verbose_name du backend, insensible à la casse)
const TEXT_FIELD_NAMES = [
  "text in french",
  "title in french",
  "text in original language",
  "title in original language",
];

export default {
  name: "StateModified",
  props: {
    context: {
      type: Object,
      required: true
    }
  },
  computed: {
    human_published_on() {
      return moment(this.context.data.published_on).fromNow();
    }
  },
  methods: {
    isTextField(verboseName) {
      return TEXT_FIELD_NAMES.includes((verboseName || "").toLowerCase());
    },
    diffOld(before, after) {
      if (!before) before = "";
      if (!after) after = "";
      const parts = diff.diffWords(String(before), String(after));
      let out = "";
      for (const part of parts) {
        if (part.removed) {
          out += '<span style="background-color:#facbcb;">' + part.value + '</span>';
        } else if (!part.added) {
          out += part.value;
        }
      }
      return out;
    },
    diffNew(before, after) {
      if (!before) before = "";
      if (!after) after = "";
      const parts = diff.diffWords(String(before), String(after));
      let out = "";
      for (const part of parts) {
        if (part.added) {
          out += '<span style="background-color:#cefacb;">' + part.value + '</span>';
        } else if (!part.removed) {
          out += part.value;
        }
      }
      return out;
    },
    delete_state() {
      this.$emit("state:delete_state");
    }
  }
};
</script>

<style lang="scss" scoped>
table {
  table-layout: fixed;
  width: 100%;
}
.field-name {
  white-space: nowrap;
  font-weight: 500;
  width: 20%;
}
.diff-cell {
  white-space: pre-wrap;
  word-break: break-word;
  width: 40%;
  overflow-wrap: break-word;
}
</style>
